import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

interface Props {
  visible: boolean;
  tips: string;
  title?: string;
  okText?: string;
  okProps?: any;
  cancelText?: string;
  cancelProps?: any;
  hideCancel?: boolean;
  onOk?(): void;
  onCancel?(): void;
}

const ModalView = (props: Props) => {
  const {
    visible,
    title,
    tips,
    onCancel,
    cancelText,
    onOk,
    okText,
    okProps,
    cancelProps,
    hideCancel,
  } = props;
  const okStyle = okProps || {};
  const cancelStyle = cancelProps || {};

  return (
    <div
      className={styles.modal}
      style={{ display: visible ? 'flex' : 'none' }}
    >
      <div className={styles.modalMain}>
        <div className={styles.modalTitle}>{title || '温馨提示'}</div>
        <div className={styles.desc}>{tips}</div>
        <div className={cn(styles.btnWrapper, hideCancel && styles.center)}>
          {!hideCancel && (
            <div
              className={[styles.btn, styles.btnCancel].join(' ')}
              onClick={() => {
                onCancel && onCancel();
              }}
              style={{ ...cancelStyle }}
            >
              <span>{cancelText || '取消'}</span>
            </div>
          )}
          <div
            className={[styles.btn, styles.btnOk].join(' ')}
            onClick={() => {
              onOk && onOk();
            }}
            style={{ ...okStyle }}
          >
            <span>{okText || '确定'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalView;
